import React, { useContext } from 'react';
import { Form } from 'react-final-form';
import { Button, Card, LocaleContext, Modal, PageHeader } from 'shared';

import * as AccountForm from '../../account/accountForm';

import { AddAccountFormFooter, AddAccountFormWrapper } from './AddAccountForm.styles';
import { AddAccountFormProps } from './AddAccountForm.types';

export const AddAccountForm = ({ onSubmit }: AddAccountFormProps) => {
  const localeContext = useContext(LocaleContext);

  return (
    <AddAccountFormWrapper className="account-add-wrapper">
      <PageHeader>{localeContext.formatMessage({ id: 'ACCOUNT.EDIT.TITLE' })}</PageHeader>
      <Form
        onSubmit={onSubmit}
        validateOnBlur={false}
        subscription={{ submitting: true }}
        initialValues={{ companyData: { country: 'Poland' } }}
      >
        {({ handleSubmit, submitting, form: { reset } }) => (
          <form onSubmit={handleSubmit} action="" className="account-add-form">
            <Card className="account-add">
              <Card.Header className="account-add-header">
                <Card.Title className="account-add__title">
                  {localeContext.formatMessage({ id: 'ACCOUNT.ACCOUNT-NAME' })}:
                </Card.Title>
              </Card.Header>
              <Card.Body>
                <Modal.Body className="account-add__body">
                  <AccountForm.AccountName />
                </Modal.Body>
              </Card.Body>
              <Card.Header className="account-add-header">
                <Card.Title className="account-add__title">
                  {localeContext.formatMessage({ id: 'ACCOUNT.COMPANY-DETAILS' })}:
                </Card.Title>
              </Card.Header>
              <Card.Body>
                <Modal.Body className="account-add__body">
                  <AccountForm.CompanyDetails />
                </Modal.Body>
              </Card.Body>
              <Card.Header className="account-add-header">
                <Card.Title className="account-add__title">
                  {localeContext.formatMessage({ id: 'ACCOUNT.CONTACT-INFORMATION' })}:
                </Card.Title>
              </Card.Header>
              <Card.Body>
                <Modal.Body className="account-add__body">
                  <AccountForm.ContactInformation />
                </Modal.Body>

                <AddAccountFormFooter>
                  <Button
                    type="leading-flat"
                    htmlType="button"
                    className="account-add__cancel"
                    onClick={reset}
                    disabled={submitting}
                  >
                    {localeContext.formatMessage({ id: 'GENERAL.CANCEL' })}
                  </Button>
                  <Button type="leading" className="account-add__submit" disabled={submitting}>
                    {localeContext.formatMessage({ id: 'GENERAL.SAVE' })}
                  </Button>
                </AddAccountFormFooter>
              </Card.Body>
            </Card>
          </form>
        )}
      </Form>
    </AddAccountFormWrapper>
  );
};
